import { render, staticRenderFns } from "./MediaThumb.vue?vue&type=template&id=230fef7e&scoped=true"
import script from "./MediaThumb.vue?vue&type=script&lang=js"
export * from "./MediaThumb.vue?vue&type=script&lang=js"
import style0 from "./MediaThumb.vue?vue&type=style&index=0&id=230fef7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230fef7e",
  null
  
)

export default component.exports